"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _reactIntl = require("react-intl");
var _Grid = _interopRequireDefault(require("@mui/material/Grid"));
var _labelConsts = require("../../../constants/labelConsts");
var _stringUtil = _interopRequireDefault(require("../../../logics/stringUtil"));
var _LabelValueDisplay = _interopRequireDefault(require("../../layout/LabelValueDisplay"));
var _CLabel = _interopRequireDefault(require("../../materials/CLabel"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * アップロード済みファイル情報／削除ファイル情報部品
 */
const FileInfoParts = props => {
  const {
    intl,
    title,
    fileInfo
  } = props;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_Grid.default, {
    size: {
      xs: 12
    }
  }, /*#__PURE__*/_react.default.createElement(_CLabel.default, {
    label: title
  })), /*#__PURE__*/_react.default.createElement(_Grid.default, {
    size: {
      xs: 12
    }
  }, /*#__PURE__*/_react.default.createElement(_LabelValueDisplay.default, {
    label: intl.formatMessage({
      id: _labelConsts.LABEL.CORE_FILE_NAME
    }),
    value: _stringUtil.default.emptyToHyphen(fileInfo.fileNm),
    labelWidth: 200
  })), /*#__PURE__*/_react.default.createElement(_Grid.default, {
    size: {
      xs: 12
    }
  }, /*#__PURE__*/_react.default.createElement(_LabelValueDisplay.default, {
    label: intl.formatMessage({
      id: _labelConsts.LABEL.CORE_DESCRIPTION
    }),
    value: _stringUtil.default.emptyToHyphen(fileInfo.note),
    labelWidth: 200
  })), /*#__PURE__*/_react.default.createElement(_Grid.default, {
    size: {
      xs: 12
    }
  }, /*#__PURE__*/_react.default.createElement(_LabelValueDisplay.default, {
    label: intl.formatMessage({
      id: _labelConsts.LABEL.CORE_LAST_UPLOAD_DATE
    }),
    value: _stringUtil.default.emptyToHyphen(fileInfo.updDt),
    labelWidth: 200
  })));
};
FileInfoParts.propTypes = {
  fileInfo: _propTypes.default.object.isRequired
};
var _default = exports.default = (0, _reactIntl.injectIntl)(FileInfoParts);